import type { SupabaseClient } from "@supabase/supabase-js";
import type { UIMessage } from "ai";

/**
 * CartAssistant thread persistence in public.assistant_threads (RLS-scoped to
 * the Clerk user).
 */
export interface AssistantThreadRow {
  id: string;
  name: string | null;
  created_at: string;
  updated_at: string;
  messages?: UIMessage[];
}

const TABLE = "assistant_threads";

export const listThreads = async (supabase: SupabaseClient, limit = 30): Promise<AssistantThreadRow[]> => {
  const { data, error } = await supabase
    .from(TABLE)
    .select("id, name, created_at, updated_at")
    .order("updated_at", { ascending: false })
    .limit(limit);
  if (error) throw error;
  return data || [];
};

export const loadThread = async (supabase: SupabaseClient, id: string): Promise<AssistantThreadRow | null> => {
  const { data, error } = await supabase
    .from(TABLE)
    .select("id, name, created_at, updated_at, messages")
    .eq("id", id)
    .maybeSingle();
  if (error) throw error;
  return data;
};

export const saveThread = async (
  supabase: SupabaseClient,
  thread: { id: string; userId: string; name: string | null; messages: UIMessage[] },
) => {
  const { error } = await supabase.from(TABLE).upsert({
    id: thread.id,
    user_id: thread.userId,
    name: thread.name,
    messages: thread.messages,
    updated_at: new Date().toISOString(),
  });
  if (error) throw error;
};

export const renameThread = async (supabase: SupabaseClient, id: string, name: string) => {
  const { error } = await supabase.from(TABLE).update({ name }).eq("id", id);
  if (error) throw error;
};

export const deleteThread = async (supabase: SupabaseClient, id: string) => {
  const { error } = await supabase.from(TABLE).delete().eq("id", id);
  if (error) throw error;
};
